import controller from './qr-code-scanner.controller';
import template from './qr-code-scanner.html';

export default {
	template,
	bindings: {
		ngModel: '=',
		message: '<?',
		ready:   '<?',
	},
	controller,
	controllerAs: '$ctrl',
	require:  {
		ngModelCtrl: 'ngModel',
	},
};
